import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import Logo from '../common/Logo';

const navItems = [
  { id: 'dashboard', label: 'Command Center', icon: 'Box' },
  { id: 'demo', label: 'Demo', icon: 'Zap' },
  { id: 'alerts', label: 'Reorder Alerts', icon: 'AlertTriangle' },
  { id: 'forecast', label: 'Demand Forecast', icon: 'TrendingUp' },
  { id: 'zones', label: 'Warehouse Zones', icon: 'Map' },
  { id: 'suppliers', label: 'Suppliers', icon: 'Truck' },
  { id: 'queue', label: 'Purchase Queue', icon: 'ShoppingCart' },
  { id: 'audit', label: 'Audit Log', icon: 'List' },
];

const Sidebar = ({ activeTab, setActiveTab }) => {
  return (
    <div className="w-64 bg-sp-black border-r border-sp-gray-800 h-screen flex flex-col hidden md:flex z-10 relative">
      <div className="p-6 flex items-center gap-3">
        <Logo className="w-10 h-10 text-sp-lime" />
        <div>
          <h1 className="text-xl font-bold tracking-tight text-white leading-tight">StockPilot</h1>
          <p className="text-[10px] text-sp-lime font-mono tracking-widest uppercase">SYS.ONLINE</p>
        </div>
      </div>

      <div className="px-4 pb-4 flex-grow overflow-y-auto custom-scrollbar">
        <div className="text-xs text-gray-500 font-mono mb-2 uppercase tracking-wider px-3">Modules</div>
        <nav className="flex flex-col gap-1">
          {navItems.map((item) => {
            const isActive = activeTab === item.id;
            return (
              <button
                key={item.id}
                onClick={() => setActiveTab(item.id)}
                className={`relative flex items-center gap-3 px-3 py-2.5 rounded-md transition-all duration-200 text-sm group ${
                  isActive ? 'text-sp-lime bg-sp-gray-900 border border-sp-gray-800' : 'text-gray-400 hover:text-white hover:bg-sp-gray-800/50'
                }`}
              >
                {isActive && (
                  <motion.div 
                    layoutId="activeNavInd" 
                    className="absolute left-0 top-1 bottom-1 w-1 bg-sp-lime rounded-r-md shadow-neon" 
                  />
                )}
                <SafeIcon name={item.icon} className={`text-lg ${isActive ? 'text-sp-lime' : 'text-gray-500 group-hover:text-gray-300'}`} />
                <span className="font-medium">{item.label}</span>
              </button>
            );
          })}
        </nav>
      </div>

      <div className="mt-auto p-4 border-t border-sp-gray-800">
        <div className="bg-sp-gray-900 rounded-md p-3 border border-sp-gray-700">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-2 h-2 rounded-full bg-sp-lime shadow-neon animate-pulse"></div>
            <span className="text-xs font-mono text-gray-300 uppercase tracking-tighter">Health: 99.9%</span>
          </div>
          <div className="w-full bg-sp-black h-1.5 rounded-full overflow-hidden">
            <div className="bg-sp-lime w-[99.9%] h-full shadow-neon"></div>
          </div>
        </div>
        
        <div className="mt-6 flex flex-col items-center gap-2 opacity-60">
          <Logo className="w-5 h-5 opacity-30" glow={false} />
          <div className="text-center">
            <p className="text-[9px] text-gray-600 font-mono uppercase tracking-[0.2em]">Deployment: SP-V2</p>
            <p className="text-[9px] text-gray-500 font-medium mt-0.5">Made by LingLink AI and DigLab AI</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;